import React from 'react';

import { borderGrey } from 'common/constants/colors';
import PaneHeader from '../../components/PaneHeader';
import PaneItem from './PaneItem';
import { DerivedAttributeMap } from '../interfaces';

interface Props {
    addNew: () => void;
    paneName: string;
    paneItems?: DerivedAttributeMap[];
    onSelectItem?: (item: DerivedAttributeMap) => void;
    selectedItem?: DerivedAttributeMap;
}

const NaturalPane = ({
  paneName,
  paneItems,
  onSelectItem,
  selectedItem,
  addNew,
}: Props) => (
  <div
    style={{
      borderRight: `solid 1px ${borderGrey}`,
      width: '50vw',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <PaneHeader onAdd={addNew} paneName={paneName} />
    <div style={{ padding: '10px', overflow: 'auto' }}>
      { paneItems && paneItems.map(item =>
        (
          <PaneItem
            isSelected={selectedItem === item}
            item={item.attribute}
            key={JSON.stringify(item.attribute)}
            onClick={() => onSelectItem?.(item)}
          />
        )
      )}
    </div>
  </div>
);

export default NaturalPane;
